import React, { useState } from "react";
import classNames from "classnames";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import OTPInput from "react-otp-input";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./Auth.scss";
import LeftPanel from "./LeftPanel";

export function ResetPassword() {
  const navigate = useNavigate();
  const mobileReg = /^(\+\d{1,3}[-]?)?\d{10}$/;
  const passReg =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_])[A-Za-z\d@$!%*?&_]{8,}$/;
  const [formData, setFormData] = useState({
    phone_number: "",
    password: "",
    confirm_password: "",
  });
  const [validation, setValidation] = useState({
    invalidPhone: false,
    invalidPass: false,
    invalidConfPass: false,
  });
  const [otpError, setOTPError] = useState(false);
  const [invalidMobileError, setInvalidMobileError] = useState(false);
  const [invalidMobileErrorMessage, setInvalidMobileErrorMessage] =
    useState("");
  const [resendMessage, setResendMessage] = useState(false);
  const [securityCodeError, setSecurityCodeError] = useState(false);
  const [securityCodeErrorMessage, setSecurityCodeErrorMessage] =
    useState(false);
  const [nextDisable, setNextDisable] = useState(true);
  const [otp, setOTP] = useState("");
  const [viewPass, setViewPass] = useState(true);
  const [viewConfirmPass, setViewConfirmPass] = useState(true);
  const [steps, setSteps] = useState(0);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const onChange = (e) => {
    // console.log("onChange = ", e.target.name);
    setInvalidMobileError(false);
    setSecurityCodeError(false);
    if (e.target.name === "phone_number") {
      e.target.value = e.target.value.replace(/[^0-9-+]/gi, "");
      if (e.target.value.length > 0) {
        setNextDisable(false);
        setValidation({ ...validation, invalidPhone: false });
      } else {
        setNextDisable(true);
      }
    } else {
      if (e.target.name === "password") {
        if (e.target.value.length > 0 && formData.confirm_password.length > 0) {
          setNextDisable(false);
        } else {
          setNextDisable(true);
        }
        setValidation({ ...validation, invalidPass: false });
      }
      if (e.target.name === "confirm_password") {
        if (e.target.value.length > 0 && formData.password.length > 0) {
          setNextDisable(false);
        } else {
          setNextDisable(true);
        }
        setValidation({ ...validation, invalidConfPass: false });
      }
    }
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleMobile = (phone) => {
    setInvalidMobileError(false);
    setSecurityCodeError(false);
    if (phone.length > 0) {
      setNextDisable(false);
      setValidation({ ...validation, invalidPhone: false });
    } else {
      setNextDisable(true);
    }
    let final_phone = "+" + phone;
    setFormData({ ...formData, ["phone_number"]: final_phone });
  };

  const moveStepsBack = () => {
    if (steps === 0) {
      navigate("/signin");
    } else if (steps === 3) {
      navigate("/signin");
    } else {
      setOTP("");
      setFormData({ ...formData, password: "", confirm_password: "" });
      setValidation({
        ...validation,
        invalidPass: false,
        invalidConfPass: false,
      });
      setSecurityCodeError(false);
      setInvalidMobileError(false);
      if (steps > 1) {
        setNextDisable(true);
      } else {
        setNextDisable(false);
      }
      setSteps(steps - 1);
    }
  };

  const sendSecurityCode = () => {
    setInvalidMobileError(false);
    if (!mobileReg.test(formData.phone_number)) {
      setValidation({ ...validation, invalidPhone: true });
      return false;
    } else {
      setValidation({ ...validation, invalidPhone: false });
    }
    let final_phone_number = formData.phone_number;
    final_phone_number = final_phone_number.replace(/-/g, ""); // remove - as cognito doesnt accept it.
    Auth.forgotPassword(final_phone_number)
      .then((data) => {
        // console.log(data);
        setNextDisable(true);
        setSteps(steps + 1);
        setTimeout(() => {
          let input = document.querySelectorAll(".otpInput input");
          input[0].focus();
        }, 200);
      })
      .catch((err) => {
        const { code } = err;
        switch (code) {
          case "UserNotFoundException": {
            setInvalidMobileErrorMessage("Incorrect Registered Mobile Number");
            setInvalidMobileError(true);
            break;
          }
          case "LimitExceededException": {
            setInvalidMobileErrorMessage(
              "Attempt limit exceeded, please try after some time."
            );
            setInvalidMobileError(true);
            break;
          }
          default:
            setInvalidMobileErrorMessage("");
        }
      });
  };

  const resendConfirmationCode = () => {
    setSecurityCodeError(false);
    let final_phone_number = formData.phone_number;
    final_phone_number = final_phone_number.replace(/-/g, ""); // remove - as cognito doesnt accept it.
    Auth.forgotPassword(final_phone_number)
      .then((data) => {
        // console.log(data);
        setResendMessage(true);
        setTimeout(() => {
          setResendMessage(false);
        }, 5000);
      })
      .catch((err) => {
        // console.log(err);
        setResendMessage(false);
        const { code } = err;
        switch (code) {
          case "LimitExceededException": {
            setSecurityCodeErrorMessage(
              "Attempt limit exceeded, please try after some time."
            );
            setSecurityCodeError(true);
            break;
          }
          default:
            setSecurityCodeErrorMessage("");
        }
      });
  };

  const resetPassword = () => {
    setSecurityCodeError(false);
    if (!passReg.test(formData.password)) {
      setValidation({ ...validation, invalidPass: true });
      return false;
    } else {
      setValidation({ ...validation, invalidPass: false });
    }
    if (formData.confirm_password.length < 8) {
      setValidation({ ...validation, invalidConfPass: true });
      return false;
    } else {
      if (formData.confirm_password !== formData.password) {
        setValidation({ ...validation, invalidConfPass: true });
        return false;
      } else {
        setValidation({ ...validation, invalidConfPass: false });
      }
    }
    let final_phone_number = formData.phone_number;
    final_phone_number = final_phone_number.replace(/-/g, ""); // remove - as cognito doesnt accept it.
    setIsSubmitted(true);
    Auth.forgotPasswordSubmit(final_phone_number, otp, formData.password)
      .then((data) => {
        setIsSubmitted(false);
        setSteps(steps + 1);
        setTimeout(() => {
          navigate("/signin");
        }, 3000);
      })
      .catch((err) => {
        setIsSubmitted(false);
        const { code } = err;
        switch (code) {
          case "CodeMismatchException": {
            setSecurityCodeErrorMessage("Incorrect Mobile Security Code!");
            setSecurityCodeError(true);
            break;
          }
          case "ExpiredCodeException": {
            setSecurityCodeErrorMessage(
              "Security code expired, please try again"
            );
            setSecurityCodeError(true);
            break;
          }
          case "LimitExceededException": {
            setSecurityCodeErrorMessage(
              "Attempt limit exceeded, please try after some time."
            );
            setSecurityCodeError(true);
            break;
          }
          default:
            setSecurityCodeErrorMessage("");
        }
      });
  };

  const checkOTP = () => {
    setSecurityCodeError(false);
    if (otp.length < 6) {
      setOTPError(true);
    } else {
      setOTPError(false);
      setNextDisable(true);
      setSteps(steps + 1);
    }
  };
  const onOTPChange = (val) => {
    setSecurityCodeError(false);
    setOTP(val);
    if (val.length < 6) {
      setNextDisable(true);
    } else {
      setNextDisable(false);
    }
    setInvalidMobileError(false);
    setOTPError(false);
  };
  const viewPassword = () => {
    setViewPass(!viewPass);
  };
  const viewConfirmPassword = () => {
    setViewConfirmPass(!viewConfirmPass);
  };

  const handleKeypress = (e) => {
    if (e.key === "Enter") {
      if (steps === 0 && !nextDisable) sendSecurityCode();
      if (steps === 1 && !nextDisable) checkOTP();
      if (steps === 2 && !nextDisable) resetPassword();
    }
  };

  return (
    <>
      <section className="authContainer">
      <LeftPanel />

        <div className="rightPanel">
          <img
            id="logo"
            src={require("../../assets/images/chorus-rgb.png")}
            className="img-fluid logo mb-4"
            alt="chorus"
          />
          <div className="container-fluid backBtnWrapper">
            <button
              onClick={moveStepsBack}
              id="back"
              name="back"
              className="linkBtn"
            >
              {"< Back"}
            </button>
          </div>
          <div className="container-fluid d-flex flex-row justify-content-center mb-4 align-items-center">
            <img
              id="mobile_logo"
              src={require("../../assets/images/smartphone.png")}
              className="img-fluid"
              alt="reset-password"
            />
          </div>

          <div
            className={classNames("container-fluid flex-fill", {
              "d-none": steps !== 0,
            })}
            onKeyDown={handleKeypress}
          >
            <div className="fieldset d-flex flex-column text-center justify-content-center mb-4 align-items-center">
              <p className="fs-6 mb-0 text-dark" id="reset-pass-text">
                Reset Password
              </p>
              <p className="fs-7" id="enter-mob-text">
                Please input your registered mobile number below
              </p>
            </div>
            <div className="fieldset mb-4">
              <label id="mobile_label">Mobile Number</label>
              <div className="input-group">
                {/* <input type="text" className="form-control" id="phonenumber" placeholder="Enter registered mobile number" aria-label="Username" aria-describedby="basic-addon1" value={formData.phone_number} name="phone_number" onChange={onChange} /> */}
                <PhoneInput
                  country={"us"}
                  placeholder="Enter registered mobile number"
                  onChange={handleMobile}
                  value={formData.phone_number}
                  className="phone-input"
                />
              </div>
              {validation.invalidPhone && (
                <span id="mobile_error1" className="validationError">
                  That Phone Number does not look right. Please check Country
                  Code and Phone Number.
                </span>
              )}
            </div>
            {invalidMobileError && (
              <div className="fieldset mb-4">
                <span id="mobile_error2" className="validationError">
                  {invalidMobileErrorMessage}
                </span>
              </div>
            )}
            <div className="fieldset mb-4">
              <button
                type="submit"
                id="sendcode"
                className={classNames("submitBtn", {
                  dark: nextDisable,
                })}
                disabled={nextDisable}
                onClick={sendSecurityCode}
              >
                Send Security Code
              </button>
            </div>
          </div>

          <div
            className={classNames("container-fluid flex-fill", {
              "d-none": steps !== 1,
            })}
            onKeyDown={handleKeypress}
          >
            <div className="fieldset d-flex flex-column text-center justify-content-center mb-4 align-items-center">
              <p className="fs-6 mb-0 text-dark" id="resetpass-enter-code-text">
                Please Enter Security Code to Reset your Password
              </p>
              <p className="fs-7" id="code-sent-text">
                A security code is sent to {formData.phone_number}
              </p>
            </div>
            <div className="fieldset d-flex flex-column justify-content-center mb-4 otpInputWrapper">
              <label id="code_label">Security Code</label>
              <br />
              <OTPInput
                value={otp}
                className="otpInput"
                focusStyle={{
                  border: "1px solid #CFD3DB",
                  outline: "none",
                }}
                onChange={(val) => {
                  onOTPChange(val);
                }}
                separator={<span style={{ width: "8px" }}> </span>}
                shouldAutoFocus={true}
                numInputs={6}
                isInputNum={true}
                isDisabled={false}
                isInputSecure={true}
              />
              {otpError && (
                <span className="validationError">
                  Incorrect Mobile Security Code!
                </span>
              )}
            </div>
            {securityCodeError && (
              <div className="fieldset mb-4">
                <span className="validationError">
                  {securityCodeErrorMessage}
                </span>
              </div>
            )}
            {resendMessage && (
              <div className="fieldset mb-4">
                <p
                  className="fs-7 mb-0 successMsg text-center"
                  id="code-resent-text"
                >
                  Security Code resent to {formData.phone_number}
                </p>
              </div>
            )}
            <div className="fieldset d-flex flex-row justify-content-between align-items-center mb-4">
              <button
                onClick={moveStepsBack}
                id="wrongnumber"
                name="wrongnumber"
                className="linkBtn"
              >
                Entered a wrong number?
              </button>
              <button
                onClick={resendConfirmationCode}
                id="resendcode"
                name="resendcode"
                className="linkBtn"
              >
                Resend Security Code
              </button>
            </div>
            <div className="fieldset mb-4">
              <button
                type="submit"
                id="next"
                className={nextDisable || isSubmitted ? "submitBtn dark" : "submitBtn"}
                disabled={nextDisable || isSubmitted}
                onClick={checkOTP}
              >
                {isSubmitted ? (
                  <span>
                    Loading....
                    <div
                      className="spinner-border spinner-border-sm"
                      role="status"
                    ></div>
                  </span>
                ) : (
                  <span>Next</span>
                )}
              </button>
            </div>
          </div>

          <div
            className={classNames("container-fluid flex-fill", {
              "d-none": steps !== 2,
            })}
            onKeyDown={handleKeypress}
          >
            <div className="fieldset d-flex flex-column text-center justify-content-center mb-4 align-items-center">
              <p className="fs-6 mb-0 text-dark" id="enter-pass-text">
                Enter your New Password
              </p>
            </div>
            <div className="fieldset mb-4">
              <label id="pass_label">New Password</label>
              <div className="input-group">
                <input
                  type={viewPass ? "password" : "text"}
                  className="form-control"
                  id="password"
                  value={formData.password}
                  placeholder="Enter your password"
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  name="password"
                  maxLength="64"
                  onChange={onChange}
                />
                <span
                  className="input-group-text"
                  id="viewpass"
                  onClick={viewPassword}
                >
                  {!viewPass && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="#7159A5"
                      className="bi bi-eye"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                      <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                    </svg>
                  )}
                  {viewPass && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="#7159A5"
                      className="bi bi-eye-slash"
                      viewBox="0 0 16 16"
                    >
                      <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
                      <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
                      <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z" />
                    </svg>
                  )}
                </span>
              </div>
              {validation.invalidPass && (
                <span className="validationError">
                  Password field must be at least 8 characters and contain at
                  least one capital letter, one small letter, one number, and
                  one special character from: @$!%*?&_
                </span>
              )}
            </div>
            <div className="fieldset mb-4">
              <label id="confirmpass_label">Confirm Password</label>
              <div className="input-group">
                <input
                  type={viewConfirmPass ? "password" : "text"}
                  className="form-control"
                  id="confirmpassword"
                  value={formData.confirm_password}
                  placeholder="Confirm your password"
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  name="confirm_password"
                  maxLength="64"
                  onChange={onChange}
                />
                <span
                  className="input-group-text"
                  id="viewconfirmpass"
                  onClick={viewConfirmPassword}
                >
                  {!viewConfirmPass && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-eye"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                      <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                    </svg>
                  )}
                  {viewConfirmPass && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-eye-slash"
                      viewBox="0 0 16 16"
                    >
                      <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
                      <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
                      <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z" />
                    </svg>
                  )}
                </span>
              </div>
              {validation.invalidConfPass && (
                <span id="pass_error" className="validationError">
                  Password and Confirm Password does not match
                </span>
              )}
            </div>
            {securityCodeError && (
              <div className="fieldset mb-4">
                <span id="code_error" className="validationError">
                  {securityCodeErrorMessage}
                </span>
              </div>
            )}
            <div className="fieldset mb-4">
              <button
                type="submit"
                id="reset"
                className={nextDisable ? "submitBtn dark" : "submitBtn"}
                disabled={nextDisable}
                onClick={resetPassword}
              >
                Reset
              </button>
            </div>
          </div>
          <div
            className={classNames("container-fluid pt-5 mt-5 flex-fill", {
              "d-none": steps !== 3,
            })}
          >
            <div className="fieldset d-flex flex-column text-center justify-content-center mb-4 align-items-center">
              <p
                className="fs-6 mb-0 test-dark successMsg fw-semibold"
                id="pass-update-text"
              >
                Password updated successfully!
              </p>
            </div>
          </div>
          <div className="fieldset text-center" id="copyright-text">
            All rights reserved © Copyright Chorus LLC 2023
          </div>
        </div>
      </section>
    </>
  );
}

export default ResetPassword;
